import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import useAppStore from '../../store';
import { SESSION_STATUS } from '../../store/slices/sessionSlice';

/**
 * Auth gate (T8.7). While the persisted session hydrates, hold a neutral
 * screen instead of guessing (avoids a login flash on refresh). Once resolved,
 * anonymous users go to /login with the intended location stashed so
 * post-login can return them to the deep link (T8.8).
 *
 * UX gating only — the backend must re-verify every request (auth-permissions.md).
 */
function RequireAuth({ children }) {
  const location = useLocation();
  const sessionStatus = useAppStore((state) => state.sessionStatus);

  if (sessionStatus === SESSION_STATUS.HYDRATING) {
    return <div className="route-loading" role="status" aria-label="Restoring session" />;
  }

  if (sessionStatus === SESSION_STATUS.ANONYMOUS) {
    return <Navigate replace state={{ from: location }} to="/login" />;
  }

  return children;
}

export default RequireAuth;
